import { ITGExecutionTransformation } from "@ceeferenderer/itg-renderer-sdk";
import { itgConfig } from "../config/itgConfig";
import { flowConfig } from "../config/flowConfigs";
import { envConfig } from "../config/envConfigs";
import { Constants } from "@ceeferenderer/itg-renderer-sdk/common/util";

Constants.SELECTED = "data-selected";

export const itgExecution = new ITGExecutionTransformation({
  ...itgConfig,
  ...envConfig.itgConfig,
  ...flowConfig.itgConfig,
});
